module.exports = __webpack_public_path__ + "static/media/asc-headset.93e4e6b7.svg";